const LiveRoom = () => import(/* webpackChunkName: "liveroom" */ './LiveRoom.vue')
const LiveVideo = () => import(/* webpackChunkName: "liveroom" */ './sub/LiveVideo.vue')
const ReplayVideo = () => import(/* webpackChunkName: "liveroom" */ './sub/ReplayVideo.vue')
const LiveCourses = () => import(/* webpackChunkName: "livecourse" */ './LiveCourses.vue')
const LiveCourseDetail = () => import(/* webpackChunkName: "livecourse" */ './LiveCourseDetail.vue')

export { LiveRoom, LiveVideo, ReplayVideo, LiveCourses, LiveCourseDetail }
